<template>
  
  <div class="layout-box" :style="{ backgroundColor: info.backgroundColor }">
    <div class="banner-box" :style="{ backgroundImage: `url(${info.pcBannerImage})` }"></div>
    <div class="form-box">
      <div class="form-title">参会人信息</div>
      <el-form
          ref="form"
          class="form"
          :model="form"
          :rules="rules"
          label-width="280px"
          size="large"
          @submit.prevent
          :disabled="disabledForm"
      >
        <el-form-item prop="userName" label="姓名">
          <el-input
              v-model.trim="form.userName"
              :maxlength="100"
              placeholder="请填写参会人的姓名"
          />
        </el-form-item>
        <el-form-item prop="userPosition" label="职位">
          <el-input
              v-model.trim="form.userPosition"
              :maxlength="100"
              placeholder="请填写参会人的职位"
          />
        </el-form-item>
        <el-form-item prop="phone" label="联系电话">
          <el-input
              v-model.trim="form.phone"
              :maxlength="11"
              placeholder="请填写参会人的电话"
          />
        </el-form-item>
        <el-form-item prop="imgCaptcha" label="图形验证码">
          <el-row class="w-p-100 h-40" justify="space-between">
            <el-col :span="18">
              <el-input v-model.trim="form.imgCaptcha" placeholder="请填写图形验证码"/>
            </el-col>
            <el-col :span="6" class="imgCode">
              <el-image class="cursor" :src="imgKeyData.img" @click="getImgCaptcha">
                <div slot="placeholder" class="image-slot">
                  加载中<span class="dot">...</span>
                </div>
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline icon"></i>
                </div>
              </el-image>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item prop="wechat" label="微信号">
          <el-input
              v-model.trim="form.wechat"
              :maxlength="100"
              placeholder="请填写参会人的微信"
          />
        </el-form-item>
        <el-form-item prop="email" label=" 电子邮箱">
          <el-input
              v-model.trim="form.email"
              :maxlength="50"
              placeholder="请填写参会人的电子邮箱"
          />
        </el-form-item>
        <el-form-item prop="companyName" label="公司名称">
          <el-input
              v-model.trim="form.companyName"
              :maxlength="100"
              placeholder="请填写参会人的公司名称"
          />
        </el-form-item>
        <el-form-item label="">
          <el-tooltip v-if="disabledForm" placement="top">
              <div slot="content" >未在活动报名期间</div>
              <el-button
                  class="submit-btn"
                  type="primary"
                  size="large"
              >
                提交报名
              </el-button>
          </el-tooltip>
          <el-button
            v-else
            class="submit-btn"
            type="primary"
            size="large"
            :disabled="loading"
            @click="submitForm()">
                提交报名
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="rules-box" v-if="info.rules">
      <div class="rules-title">报名须知</div>
      <div class="rules-content" v-html="info.rules">
      </div>
    </div>
  </div>
</template>
<script>
import { singleActivitySever } from "@/common/api-config";
export default {
  data() {
    //验证码检验
    var checkImgCaptcha = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入图形中的验证码"));
      } else if (value.length == 4) {
        singleActivitySever
          .checkImgCaptcha({
            imgCaptcha: value,
            ckey: this.form.ckey,
          })
          .then((res) => {
            if (res.code == 0) {
              callback();
            } else if (res.code == 1019) {
              // 图片验证码过期，需要重新获取图片验证码
              this.getImgCaptcha();
              callback(new Error("图形验证码已失效"));
            } else {
              callback(new Error("图形验证码输入错误"));
            }
          });
      } else {
        callback(new Error("图形验证码输入错误"));
      }
    };
    return {
      loading:false,
      disabledForm: false,
      info:{
        pcBannerImage: '',
        h5BannerImage: '',
        backgroundColor: '',
        rules: '',
      },
      form: {
        organizerActivityId: "",
        userName: "",
        userPosition: "",
        phone: "",
        email: "",
        imgCaptcha: "",
        companyName: "",
        wechat: "",
      },
      formValid: {},
      imgKeyData: {},
      rules: {
        userName: [{required: true, message: "不可为空", trigger: "blur"}],
        userPosition: [{required: true, message: "不可为空", trigger: "blur"}],
        phone: [
          {required: true, message: "不可为空", trigger: "blur"},
          {
            pattern: /^1[0-9]{10}$/,
            message: '请输入合法的手机号码',
            trigger: 'blur'
          },
        ],
        imgCaptcha: [
          {required: true, message: "不可为空", trigger: "blur"},
          {validator: checkImgCaptcha, trigger: "blur"}
        ],
        wechat: [{required: true, message: "不可为空", trigger: "blur"}],
        email: [
          {required: true, message: "不可为空", trigger: "blur"},
          {
            pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            message: '请输入正确的邮箱格式',
            trigger: 'blur'
          },
        ],
        companyName: [{required: true, message: "不可为空", trigger: "blur"}],
      },
    };
  },
  created() {
    if(this.$route.query.id){
      this.form.organizerActivityId=this.$route.query.id;
      this.getActivityInfo();
    }else{
      this.info.pcBannerImage = this.$route.query.pcBannerImage ? decodeURIComponent(this.$route.query.pcBannerImage) : '';
      this.info.backgroundColor = this.$route.query.backgroundColor ? decodeURIComponent(this.$route.query.backgroundColor) : '#000';
      this.info.rules = this.$route.query.rules ? decodeURIComponent(this.$route.query.rules) : '';
    }
  },
  mounted() {
    this.getImgCaptcha();
  },
  methods: {
    getActivityInfo() {
      singleActivitySever.queryActivity({ id: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          const now = Date.now();
          const onlineTime = res.data.onlineTime ? new Date(res.data.onlineTime).getTime() : null;
          const offlineTime = res.data.offlineTime ? new Date(res.data.offlineTime).getTime() : null;
          const registrationStartTime = res.data.registrationStartTime ? new Date(res.data.registrationStartTime).getTime() : null;
          const registrationEndTime = res.data.registrationEndTime ? new Date(res.data.registrationEndTime).getTime() : null;
          
          if (onlineTime && now < onlineTime) {
            this.$alert('活动未开启', '提示', {
              confirmButtonText: '确定',
              callback: () => {
                this.$router.replace('/');
              }
            });
            return;
          }
          
          if (offlineTime && now > offlineTime) {
            this.$alert('活动已结束', '提示', {
              confirmButtonText: '确定',
              callback: () => {
                this.$router.replace('/');
              }
            });
            return;
          }
          
          if ((registrationStartTime && now < registrationStartTime) || (registrationEndTime && now > registrationEndTime)) {
            this.disabledForm = true;
          }
          
          this.info = res.data
        }
      });
    },
    //提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          singleActivitySever.registrationsByPc(this.form).then((res) => {
            this.loading = false;
            if (res.code == 0) {
              this.$alert('请耐心等待官方的审核', '报名成功', {
                confirmButtonText: '确定',
                callback: action => {
                  location.reload();
                }
              });
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          return false;
        }
      });
    },
    //拿图片验证码数据
    getImgCaptcha() {
      singleActivitySever.getImgCaptcha().then((res) => {
        if (res.code == 0) {
          this.imgKeyData = res.data[0].captcha;
          this.form.ckey = this.imgKeyData.key;
        }else{
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">

.layout-box {
  background-color: #000;
  .banner-box {
    width: 100%;
    height: 600px;
    background-position: 50%;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .rules-box {
    margin: 0 auto;
    width: 1200px;
    padding-bottom: 80px;

    .rules-title {
      position: relative;
      margin-bottom: 68px;
      font-weight: bold;
      font-size: 40px;
      color: #E9C799;

      &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: -32px;
        width: 100px;
        height: 8px;
        background: linear-gradient( 90deg, #FAE7BD 0%, #C7A276 100%);
        border-radius: 8px;
      }
    }

    .rules-content {
      font-size: 18px;
      color: #DDDDDD;
      line-height: 35px;
      white-space: pre-line; /* 合并空格但保留换行 */
    }
  }

  .form-box {
    margin: 0 auto;
    width: 1200px;
    padding-top: 60px;
    padding-bottom: 60px;
    .form-title {
      position: relative;
      margin-bottom: 68px;
      font-weight: bold;
      font-size: 40px;
      color: #E9C799;

      &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: -32px;
        width: 100px;
        height: 8px;
        background: linear-gradient( 90deg, #FAE7BD 0%, #C7A276 100%);
        border-radius: 8px;
      }
    }

    .form {
      padding-top: 60px;
      padding-right: 256px;
      padding-bottom: 50px;
      border-radius: 20px;
      /deep/ .el-form-item__label {
        color: #666;
      }

      /deep/ .el-input__inner {
        border: 1px solid rgba(255,255,255,0.1);
        box-shadow: 0 0 0 1px #666666;
      }

      /deep/ .el-input__inner::placeholder {
        color: #666666 !important;
        -webkit-text-fill-color: #666666 !important;
      }
      .imgCode{
        padding-left: 20px;
        height:40px;
        overflow: hidden;
        .cursor{
          width:100%;
          height:40px;
          border-radius:4px; 
          .image-slot{
            background-color:#ccc;
            text-align:center;
          }
        }
      }

      .code-box {
        display: flex;
        width: 100%;

        .code-input {
          flex: 1;
        }

        .code-btn {
          margin-left: 10px;
          width: 138px;
          background: linear-gradient(359deg, #0A40DD 0%, #0C43DC 100%);
          border-radius: 4px;
          border-color: #0A40DD;
        }
      }
    }

    .submit-btn {
      width: 200px;
      background: linear-gradient( 90deg, #FAE7BD 0%, #C7A276 100%);
      border-radius: 4px;
      border-color: #FAE7BD;
      font-size: 14px;
      color: #212121;
      font-weight: 800;
    }
  }
}

</style>

